// extracted by mini-css-extract-plugin
export default {"preview":"O3mUU","icon":"QM9LJ","title":"xdkDz","accept":"oJ9H2","button":"qs8oc"};